<template>
<div class="vliveExampleGuideCover">
    <div class="phone-model phone_model">
        <div class="vlive-guide-cover" v-if="vliveModel.guideCover.isopencover">
            <img :src="vliveModel.guideCover.coverPicture.furl +'?'+vliveModel.guideCover.coverPicture.fsize" alt="">
        </div>
    </div>
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'vliveExampleGuideCover',
    data() {
        return {
            timestamp: new Date().getTime() // 时间戳
        }
    },
    created() {
    },
    mounted() {},
    methods: {
        handleClick() {

        },
        ...mapActions([
            'setVliveModel'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'vliveModel'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.vliveExampleGuideCover {
    .phone-model{
        .vlive-guide-cover{
            width: 318px;
            height: 512px;
            img{
                width: 100%;
                height: 100%;
            }
        }
    }
}
</style>
